/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 * This defines the state of a cyber-physical system.
 * @author Charles Xie
 */

import {PortConnector} from "./blocks/PortConnector";
import {BlockView} from "./blocks/BlockView";
import {flowchart} from "./Main";

export class State {

  readonly blockStates = [];
  readonly connectorStates = [];
  readonly blockViewState;
  readonly timestamp: number;
  readonly owner: string;

  constructor(timestamp: number, owner: string) {
    this.timestamp = timestamp;
    this.owner = owner;
    flowchart.saveBlockStatesTo(this.blockStates);
    for (let c of flowchart.connectors) {
      if (c.getOutput() != null && c.getInput() != null) {
        this.connectorStates.push(new PortConnector.State(c));
      }
    }
    this.blockViewState = new BlockView.State(flowchart.blockView);
  }

}
